import MyComponent from './fpl_plan30db';

function App() {
  return <MyComponent />;
}

export default App;